App.namespace.wrap('es6.shared.fill_variables', (template, variables) => {
  if (!template) {
    throw new Error(`Couldn't fill route variable for template: ${template}`);
  }

  if (!variables || typeof variables !== 'object') {
    throw new Error('Variables must be an object');
  }

  let filled = template;
  Object.keys(variables).forEach((key) => {
    filled = filled.split(`-${key}-`).join(variables[key]);
    filled = filled.split(`{${key}}`).join(variables[key]);
  });

  return filled;
});
